import { cn } from "@/utils/theme";
import { Badge } from "@elaniintc/goes-design-system";

const PermissionType = ({
  name,
  description,
  isActive,
  showDivider = true,
  isTypeEmpty = true,
}: {
  name: string;
  description: string;
  isTypeEmpty?: boolean;
  isActive: boolean;
  showDivider?: boolean;
}) => {
  const activeVariant = isActive ? "action" : "disabled";
  const badgeVariant = isTypeEmpty ? "neutral" : activeVariant;
  return (
    <div
      className={cn(
        "flex flex-col items-start tablet:flex-row tablet:justify-between gap-2 py-2.5",
        showDivider && "border-b border-neutral-quiet",
      )}
    >
      <Badge size="sm" variant={badgeVariant} className="rounded-lg">
        {name}
      </Badge>
      <p
        className={cn(
          "leading-3xl font-normal",
          isActive ? "text-body-loud" : "text-on-disabled",
          isTypeEmpty && "text-body",
        )}
      >
        {description}
      </p>
    </div>
  );
};
export default PermissionType;
